import { AuthAssets } from '@porterin/booking-flow/src/auth/view/stores/AuthStore';
import { isDesktop } from '@porterin/lead-flow/src/components/FareEstimateHelper';
import Image from 'next/image';

import { AuthModalVariant } from '..';

export interface AuthBannerProps {
  show_mobile_banner?: boolean;
  auth_state: AuthModalVariant;
}

const AuthBanner: React.FC<AuthBannerProps> = ({
  show_mobile_banner = true,
  auth_state,
}) => {
  const mobileHeight =
    auth_state == 'login' ? 'min-h-[24rem]' : 'min-h-[15.2rem]';

  return isDesktop() ? (
    <div className="relative min-w-[38.6rem] h-full overflow-visible">
      <Image
        src={AuthAssets.desktopBanner.src}
        alt={AuthAssets.desktopBanner.alt}
        layout="fill"
        className="max-w-full object-cover"
      />
    </div>
  ) : show_mobile_banner ? (
    <div className={`relative w-full ${mobileHeight}`}>
      <Image
        src={AuthAssets.mobileBanner.src}
        alt={AuthAssets.mobileBanner.alt}
        fill={true}
        className="object-contain"
      />
    </div>
  ) : null;
};

export default AuthBanner;
